<template>
<!-- 学情信息 -->
    <div class="stuInfo">
        <div  class="search-content conditionSearchBox">
            <div class="conditionItem">
                <el-date-picker
                    v-model="dateValue"
                    @change="getTime"
                    value-format="yyyy-MM-dd"
                    type="daterange"
                    clearable
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </div>
            <div class="conditionItem">
                <el-select clearable v-model="params.condition.checkstatus"  placeholder="课时状态">
                    <el-option
                    v-for="item in classStatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="conditionItem">
                <el-input size="medium" clearable  prefix-icon="el-icon-search" placeholder="课程名称" v-model="params.condition.classcoursename" ></el-input>
            </div>
            <div class="conditionItem">
                <el-input size="medium" clearable  prefix-icon="el-icon-search" placeholder="昵称" v-model="params.condition.studentname" ></el-input>
            </div>
            <!-- <div class="conditionItem">
                <el-input size="medium" clearable  prefix-icon="el-icon-search" placeholder="姓名" v-model="params.condition.studentname" ></el-input>
            </div> -->
            <div class="conditionItem">
                <el-button type="hollowOut" @click="triggerSearch">
                    <i class="el-icon-search mr-5"></i>搜索</el-button>
                <el-button @click="resetSearchCondition">
                    <i class="el-icon-refresh mr-5"></i>重置</el-button>
            </div>
        </div>
        <div class="listBox mt-20">
             <!-- 表格 -->
            <div v-loading="loadingStatus" class="table-content mt-15">
                <el-table class="table-fixed-col" ref="multipleTable" border :data="tableData" style="width: 100%">
                    <el-table-column key="index" type="index" :width="getTableHeaderWidthByOrderCol()"  align="center" label="序号"
                        fixed="left">
                        <template slot-scope="scope">
                            <TableSort :index="scope.$index" :page="params.page" :pagesize="params.pagesize" />
                        </template>
                    </el-table-column>
                    <el-table-column width="100" key="nickname" align="center" prop="nickname" label="昵称">
                        <template slot-scope="scope">
                            <span @click="goDetail(scope.row)" class="pointer color-primary">{{scope.row.nickname}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column width="100" key="studentname" align="center" prop="studentname" label="姓名">
                    </el-table-column>
                    <el-table-column width="100" key="sexname" align="center" prop="sexname" label="性别">
                    </el-table-column>
                    <el-table-column min-width="140" key="campusname" align="center" prop="campusname" label="所在校区">
                    </el-table-column>
                    <el-table-column width="120" key="telno" align="center" prop="telno" label="联系方式">
                    </el-table-column>
                    <el-table-column min-width="140" key="classcoursename" show-overflow-tooltip align="center" prop="classcoursename" label="课程名称">
                    </el-table-column>
                    <el-table-column min-width="140" key="periodname" show-overflow-tooltip align="center" prop="periodname" label="课时名称">
                    </el-table-column>
                    <el-table-column width="130" key="periodtime" align="center" prop="periodtime" label="课时时间">
                    </el-table-column>
                    <el-table-column width="100" key="checkstatusname" align="center" prop="checkstatusname" label="课时状态">
                    </el-table-column>
                    <el-table-column width="130" key="checktime" align="center" prop="checktime" label="打卡时间">
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <el-pagination
            :hide-on-single-page="!total || total < 1"
            class="mt-20 flex ai-c jc-fd"
            @size-change="handePageSizeChange"
            @current-change="curPageChange"
            @prev-click="curPageChange"
            @next-click="curPageChange"
            layout="total, sizes, prev, pager, next"
            :total="total"
            :page-sizes="[10, 20, 30, 40, 50, 100]"
            :page-size="20"
            :current-page.sync="params.page"
            background
        ></el-pagination>
    </div>
</template>
<script>
import {getStudyListByClass} from '@/api/measApi/teachManagement.js'
import {getTableDefaultPageSize} from '@/assets/measAssets/js/tools.js'
import TableSort from '@/components/measComponents/tableSort/tableSort.vue'
export default {
    data(){
        return {
            tableData: [],
            loadingStatus: false,
            dateValue: [],
            params: {
                condition: {
                    checkstatus: '',
                    classcoursecode: '',
                    classcoursename: '',
                    classname: '',
                    code: this.$route.query.code,
                    periodname: '',
                    periodstatus: '',
                    periodtimeend: '',
                    periodtimestart: '',
                    studentcode: '',
                    studentname: ''
                },
                orderbyname: '',
                orderbyorder: '',
                page: 1,
                pagesize: getTableDefaultPageSize()
            },
            classStatus: [
                {label: '未到', value: 0},
                {label: '到课', value: 10},
                {label: '请假', value: 11},
            ],
            total: 0,
            step: 1
        }
    },
    components: {
        TableSort
    },
    created(){
        // this.getStudyListByClass()
    },
    methods: {
        init(){
            if(this.step === 1){
                 this.getStudyListByClass()
            }
        },
        getStudyListByClass(){
            this.loadingStatus = true
            getStudyListByClass(this.params).then(res => {
                this.loadingStatus = false
                this.step++
                this.tableData = res.data
                this.total = res.pageinfo.rowcount
                console.log(res,'学情')
            }).catch(err => {
                this.loadingStatus = false
            })
        },
        triggerSearch(){
            this.params.page = 1
            this.getStudyListByClass()
        },
        resetSearchCondition(){
            this.params.condition.periodtimestart = ''
            this.params.condition.periodtimeend = ''
            this.params.condition.checkstatus = ''
            this.params.condition.classcoursename = ''
            this.params.condition.studentname = ''
            this.dateValue = ''
            this.params.page = 1
            this.getStudyListByClass()
        },
        getTime(){
            if(this.dateValue && this.dateValue.length>0){
                this.params.condition.periodtimestart = this.dateValue[0]
                this.params.condition.periodtimeend = this.dateValue[1]
            }else{
                this.params.condition.periodtimestart = ''
                this.params.condition.periodtimeend = ''
            }
        },
        goDetail(row){
            this.$router.push({name: 'StudentDetails', query: {code: row.studentcode, classCode: this.$route.query.code}})
        },
        handePageSizeChange(e){
            this.params.page = 1
            this.params.pagesize = e
            this.getStudyListByClass()
        },
        curPageChange(e){
            console.log(e,'eee')
            this.params.page = 1
            this.params.page = e
            this.getStudyListByClass()
        },
    }
}
</script>
<style lang="scss" scoped>
.stuInfo{
    .listBox{
        font-size: 14px;
        .icon-add{
            margin-right: 6px;
        }
    }
}

</style>